import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { hideModal } from '../redux/action.js';
import Comps from '@owenscorning/react-library';
import styles from '../../shared/warranty-registration.module.scss';

const Modal = Comps.Connect.Modal

const LeakingModal = (props) => {
  return (
    <Modal
      onClose={props.hideModal}
      open={props.showModal}
      className={styles.addressVerificationModal}
    >
      <p>If you are experiencing leaking issues, please reach out to a contractor.
        Click <a href='/roofing/contractors'>HERE</a> for our Find a Contractor page if you do not already have one.
        If you have already done so and are still experiencing leaking issues, please call <strong>1-800-ROOFING.</strong>
      </p>
    </Modal>
  );
};


const mapStateToProps = state => (
  {
    showModal: state.showModal,
  }
);
const mapDispatchToProps = dispatch => (
  {
    hideModal: () => dispatch(hideModal()),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeakingModal);
